import { AppBar as RaAppBar } from 'react-admin';

export const AppBar = () => <RaAppBar color="primary" />;
